<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 cyan darken-4 white--text">
            Reportes inscritos feria
          </v-card-title>
  
          <v-card-text class="pt-2" >
            <v-select v-model="tipo" label="Tipo de graficas:" dense outlined :items="tipos" />
            <div v-show="tipo=='barras'">
              <div>
                <Intereses ref="refIntereses"/>
              </div>
              <div>
                <Fechas ref="refFechas"/>
              </div>
              <div>
                <Asesores ref="refAsesores"/>
              </div> 
            </div>

            <div v-show="tipo=='torta'">
              <div>
                <Interesesb ref="refInteresesb"/>
              </div> 
              <div>
                <Fechasb ref="refFechasb"/>
              </div> 
              <div>
                <Asesoresb ref="refAsesoresb"/>
              </div> 
            </div>

          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script> 
  import Intereses from './intereses.vue';
  import Fechas from './fechas.vue';
  import Asesores from './asesores.vue';
  import Interesesb from './interesesb.vue';
  import Fechasb from './fechasb.vue';
  import Asesoresb from './asesoresb.vue';

  export default {
    components:{Intereses,Fechas,Asesores,Interesesb,Fechasb,Asesoresb},
    data() {
      return {
        dialog: false,
        tipo: 'barras',
        tipos:['barras','torta'],
      };
    },
    methods: {
      async openmodal(data) { 
        this.dialog = true;
        window.console.log('uno openmodal::',data);
        setTimeout(() => {
          this.open(data)
        }, 300);
      },
      open(data){
        this.$refs.refIntereses.openmodal(data);
        this.$refs.refFechas.openmodal(data);
        this.$refs.refAsesores.openmodal(data);

        this.$refs.refInteresesb.openmodal(data);
        this.$refs.refFechasb.openmodal(data);
        this.$refs.refAsesoresb.openmodal(data);
      },
      cerrar(){
        this.dialog=false;
      },

    },
    };
  </script>
  